import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EAuthorizationProgressStep } from 'src/app/project/components/authorization-progress/authorization-progress.consts';
import { logEventInGTAG } from 'src/app/project/services/analytics/google-analytics';
import {
  EGoogleEventCategory,
  EGoogleEventIntegrations,
} from 'src/app/project/services/analytics/google-analytics.consts';

@Component({
    selector: 'pp-site-settings-integrations-tooltips',
    templateUrl: './site-settings-integrations-tooltips.component.html',
    styleUrls: ['./site-settings-integrations-tooltips.component.scss'],
    standalone: false
})
export class SiteSettingsIntegrationsTooltipsComponent {
  @Input() ppIntegrationStep: EAuthorizationProgressStep;
  @Input() ppDisabled: boolean;
  @Output() ppCancel = new EventEmitter<void>();
  @Output() ppDeactivate = new EventEmitter<void>();
  @Input() ppAssetName: string;
  @Input() ppSiteName: string;

  EAuthorizationProgressStep = EAuthorizationProgressStep;

  cancelConnection(): void {
    logEventInGTAG(EGoogleEventIntegrations.CANCEL_CONNECTION, {
      source: EGoogleEventCategory.INTEGRATIONS,
    });

    this.ppCancel.emit();
  }

  deactivateConnection(): void {
    logEventInGTAG(EGoogleEventIntegrations.DISCONNECT, {
      source: EGoogleEventCategory.INTEGRATIONS,
    });

    this.ppDeactivate.emit();
  }
}
